import { createFileRoute } from '@tanstack/react-router'
import { Shield, Database, Lock, Mail, Eye, Cookie, Users, Trash2 } from 'lucide-react'

export const Route = createFileRoute('/_regular/privacy-policy/')({
  component: PrivacyPolicyPage,
  head: () => ({
    meta: [
      { title: 'سياسة الخصوصية | سكيكيمة' },
      {
        name: 'description',
        content: 'كيف تجمع سكيكيمة بياناتك وتستخدمها وتحميها.',
      },
    ],
  }),
})

function PrivacyPolicyPage() {
  const sections = [
    {
      icon: Database,
      title: '١. المعلومات التي نجمعها',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li><strong>معلومات الحساب:</strong> الاسم، البريد الإلكتروني، رقم الهاتف (اختياري)، كلمة المرور المشفرة.</li>
          <li><strong>معلومات المتجر:</strong> اسم المتجر، الوصف، الفئة، الموقع (المدينة والحي)، الشعار، صور الغلاف.</li>
          <li><strong>معلومات المنتجات:</strong> أسماء المنتجات، الأوصاف، الأسعار، الصور، المخزون، التصنيفات.</li>
          <li><strong>بيانات التفاعل:</strong> المتابعات، الإعجابات، عمليات الحفظ، التعليقات (إن وجدت).</li>
          <li><strong>بيانات تقنية:</strong> عنوان IP، نوع المتصفح، سجل التصفح داخل المنصة، ملفات تعريف الارتباط (cookies).</li>
          <li><strong>بيانات الدفع:</strong> نستخدم بوابة دفع تابعة لجهة خارجية ولا نخزن تفاصيل بطاقات الائتمان.</li>
        </ul>
      ),
    },
    {
      icon: Eye,
      title: '٢. كيف نستخدم معلوماتك',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li>تقديم وتحسين خدمات المنصة (إنشاء المتاجر، إدارة المنتجات، البحث).</li>
          <li>التواصل معك بخصوص طلبات الموافقة أو التحديثات الهامة.</li>
          <li>تحليل الأداء وتقديم توصيات مخصصة.</li>
          <li>الامتثال للالتزامات القانونية والتنظيمية.</li>
        </ul>
      ),
    },
    {
      icon: Users,
      title: '٣. مشاركة البيانات مع أطراف ثالثة',
      content: (
        <>
          <p>لا نبيع أو نؤجر بياناتك الشخصية. قد نشاركها في الحالات التالية:</p>
          <ul className="list-disc space-y-2 pr-5 mt-2">
            <li><strong>بموافقتك الصريحة:</strong> في حالات محددة نطلب فيها إذنك.</li>
          </ul>
        </>
      ),
    },
    {
      icon: Lock,
      title: '٤. حماية بياناتك',
      content: (
        <p>نستخدم إجراءات أمنية متقدمة تشمل تشفير البيانات (SSL/TLS)، التخزين الآمن في مراكز بيانات معزولة، والنسخ الاحتياطي المنتظم. ومع ذلك، لا يمكن ضمان الأمان المطلق عبر الإنترنت.</p>
      ),
    },
    {
      icon: Shield,
      title: '٥. حقوقك',
      content: (
        <>
          <p>لك الحق في:</p>
          <ul className="list-disc space-y-2 pr-5 mt-2">
            <li>الاطلاع على بياناتك الشخصية التي نحتفظ بها.</li>
            <li>طلب تصحيح أي أخطاء.</li>
            <li>طلب حذف حسابك وبياناتك (مع مراعاة الالتزامات القانونية).</li>
            <li>الاعتراض على معالجة بياناتك لأغراض تسويقية.</li>
            <li>سحب الموافقة في أي وقت.</li>
          </ul>
          <p className="mt-3">لممارسة هذه الحقوق، تواصل معنا على <a href="mailto:contact@skikima.store" className="text-primary hover:underline">contact@skikima.store</a>.</p>
        </>
      ),
    },
    {
  icon: Trash2,
  title: '٨. حذف بياناتك',
  anchor: 'user-data-deletion',
  content: (
    <>
      <p>لديك الحق الكامل في حذف حسابك وجميع بياناتك المرتبطة به في أي وقت.</p>
      <ul className="list-disc space-y-2 pr-5 mt-2">
        <li>
          <strong>لحذف حسابك:</strong> اذهب إلى صفحة 
          <a href="/dashboard/profile" className="text-primary mx-1 hover:underline">الملف الشخصي</a>
          ثم اضغط على زر <strong>"حذف الحساب"</strong>.
        </li>
        <li>بعد تأكيد الحذف، ستتم إزالة جميع بياناتك (الملف الشخصي، المتاجر، المنتجات، المتابعات، الإعجابات) خلال ٣٠ يوماً.</li>
        <li>يمكنك أيضاً طلب الحذف عبر البريد الإلكتروني: 
          <a href="mailto:contact@skikima.store?subject=Delete%20My%20Account" className="text-primary mx-1 hover:underline">contact@skikima.store</a>
          (اذكر بريدك الإلكتروني المسجل).
        </li>
      </ul>
      <div className="mt-3 p-3 bg-yellow-50 dark:bg-yellow-950/20 rounded-lg border border-yellow-200 dark:border-yellow-800">
        <p className="text-sm text-yellow-800 dark:text-yellow-300">
          ⚠️ تحذير: حذف الحساب نهائي ولا يمكن استرجاع البيانات بعد انقضاء المهلة المحددة.
        </p>
      </div>
    </>
  ),
},
    {
      icon: Cookie,
      title: '٦. ملفات تعريف الارتباط (Cookies)',
      content: (
        <p>نستخدم ملفات تعريف الارتباط لتحسين تجربتك، وتذكر جلسات الدخول، وتحليل حركة المرور. يمكنك التحكم في إعدادات cookies من خلال متصفحك.</p>
      ),
    },
    {
      icon: Trash2,
      title: '٧. خصوصية الأطفال',
      content: (
        <p>لا نستهدف الأطفال تحت ١٦ عاماً. إذا اكتشفنا أننا جمعنا بيانات عن طفل دون موافقة الوالدين، سنقوم بحذفها فوراً.</p>
      ),
    },
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30" dir="rtl">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20 md:py-28">
        <div className="absolute inset-0 bg-grid-primary/5 [mask-image:radial-gradient(ellipse_at_center,white,transparent)]" />
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-1 text-sm text-primary mb-6">
            <Shield className="h-4 w-4" />
            <span>خصوصيتك تهمنا</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            سياسة الخصوصية
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            في سكيكيمة، نضع خصوصيتك وأمان معلوماتك على رأس أولوياتنا
          </p>
          <p className="text-sm text-muted-foreground mt-4">آخر تحديث: ١ يونيو ٢٠٢٦</p>
        </div>
      </section>

      {/* Content Cards */}
      <section className="container mx-auto px-4 pb-20">
        <div className="max-w-3xl mx-auto space-y-6">
          {sections.map((section, idx) => (
            <div key={idx}  id={section.anchor} className="group relative rounded-2xl border bg-card p-6 transition-all hover:shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <div className="rounded-full bg-primary/10 p-2 text-primary">
                  <section.icon className="h-5 w-5" />
                </div>
                <h2 className="text-xl font-semibold">{section.title}</h2>
              </div>
              <div className="text-muted-foreground leading-relaxed space-y-2">
                {section.content}
              </div>
            </div>
          ))}

          {/* Contact Card */}
          <div className="rounded-2xl border bg-gradient-to-br from-primary/5 to-transparent p-6 text-center">
            <Mail className="h-8 w-8 text-primary mx-auto mb-3" />
            <h3 className="text-lg font-semibold mb-2">لديك استفسار حول الخصوصية؟</h3>
            <p className="text-muted-foreground mb-4">نحن هنا للإجابة على أسئلتك.</p>
            <a
              href="mailto:contact@skikima.store"
              className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition"
            >
              <Mail className="h-4 w-4" />
              contact@skikima.store
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}